import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { CampaignIcon } from '../../assets';
import type { SinglePiece } from '../../types';
import { StatusText } from '../common/StatusText';
import { SocialNetworkImage } from '../images/SocialNetworkImage';
import { UsersImages } from '../images/UserImages';

interface ListElementProps extends SinglePiece {
  onClick: () => void;
  hasPublicationDate?: boolean;
}

export const InfiniteScrollListElement = ({
  profile_picture,
  user_name,
  campaign_name,
  platform,
  type,
  status,
  publication_date,
  campaign_month,
  onClick,
  hasPublicationDate,
}: ListElementProps) => {
  const { t } = useTranslation('common');
  return (
    <div
      onClick={onClick}
      className={`bg-dark-blue cursor-pointer hover:bg-gray-hover grid ${hasPublicationDate ? 'grid-cols-[3fr_4fr_1fr_2fr_2fr_1fr_1fr]' : 'grid-cols-[3fr_4fr_2fr_2fr_2fr]'} gap-4 items-center px-4 py-2 rounded-lg`}
    >
      <div className="flex flex-row gap-x-2 items-center text-left">
        <UsersImages userCount={1} userImages={[profile_picture]} influencers />
        <span>{user_name}</span>
      </div>
      <div className="flex flex-row gap-x-2 items-center">
        <CampaignIcon />
        <span>{campaign_name}</span>
      </div>
      <div className="flex items-center justify-center">
        <SocialNetworkImage
          socialNetwork={platform as any}
          size="size-[30px]"
        />
      </div>
      <span className="text-center">{t(`actionType.${type}`)}</span>
      {hasPublicationDate && (
        <div className="flex justify-center">
          <StatusText status={status as any} type="action" />
        </div>
      )}
      <span className={hasPublicationDate ? 'text-center' : 'text-right'}>
        {campaign_month}
      </span>
      {hasPublicationDate && (
        <span className="text-right">
          {publication_date
            ? dayjs(publication_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '-'}
        </span>
      )}
    </div>
  );
};
